module.exports = __webpack_public_path__ + "static/img/video-pass.67a5922c.png";